import type { Table, TableCell, TableRow } from 'mdast';
import { visit } from 'unist-util-visit';

import { csvEscape } from './stringUtilities';

const getNodeText = (node: any): string => {
  if (node.value !== undefined) {
    return node.value;
  }

  if (node.children) {
    return node.children.map(getNodeText).join('');
  }

  return '';
};

const getCellText = (cell: TableCell): string =>
  cell.children.map(getNodeText).join('');

const rowToCsv = (row: TableRow): string =>
  row.children
    .map(cell => getCellText(cell))
    .map(val => csvEscape(val))
    .join(',');

// remark plugin that builds CSV from each markdown table and adds it as a `csv` prop (via hProperties)
export const remarkTableCsv = () => (tree: any) => {
  visit(tree, 'table', (node: Table) => {
    const csv = node.children
      .map(row => rowToCsv(row))
      .filter(val => !!val)
      .join('\n');

    node.data = node.data ?? {};
    node.data.hProperties = { ...node.data.hProperties, csv };
  });
};
